import { axios } from "../../../lib/axios"

export const getRequisitions = (patientId) => {
    return axios.get(`servicerequest?patientId=${patientId}`)
}